// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const entei: PokeData = {
  "id": 244,
  "name": "entei",
  "height": 21,
  "weight": 1980,
  "base_experience": 261,
  "types": [
    PokeType.FIRE
  ],
  "api_moves": [
    "stomp",
    "leer",
    "bite",
    "roar",
    "ember",
    "flamethrower",
    "fire-spin",
    "smokescreen",
    "fire-blast",
    "flame-wheel",
    "scary-face",
    "swagger",
    "sacred-fire",
    "sunny-day",
    "crunch",
    "extreme-speed",
    "eruption",
    "extrasensory",
    "calm-mind",
    "fire-fang",
    "lava-plume"
  ],
  "moves": [
    "leer",
    "bite",
    "ember",
    "flamethrower",
    "fire-spin",
    "scary-face",
    "sunny-day",
    "crunch",
    "eruption",
    "calm-mind",
    "fire-fang",
    "flare-blitz",
    "magma-storm"
  ],
  "evolution_chain": {
    "id": 124,
    "item": null,
    "species": [
      {
        "name": "entei",
        "order": 269,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 125,
    "speed": 128,
    "ability_power": 147
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
